// extracted by mini-css-extract-plugin
export default {"register-table__wrapper":"RegisterSparePartTable_register-table__wrapper__+L7qW","dropdown__wrapper":"RegisterSparePartTable_dropdown__wrapper__tA5-l"};